module.exports = {"id":"204497","name":"Kevin Stöger","rating":"73","photo":"./data/images/photos/0/204497.png","club":{"name":"VfL Bochum","logo":"./data/images/clubs/VfLBochum.png"},"positions":["MOC","MG","MC"],"photoFolderIndex":0}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/KevinStoger0.json
// module id = 2353
// module chunks = 0